// eslint-disable-next-line
import { 
  GetLocalWeather,
  GetMicroWeather,
  GetWeatherPrecipitation,
  GetAlertByCourse,
  GetAlertsDashboard,
  GetTasksDashboard,
  GetRecentCommentsDashboard,
  GetStationMinMaxTemps,
} from '@/api/api';

export default {
  namespaced: true,
  state: { /* = data */
    localWeather: {},
    microWeather: {},
    weatherPrecipitation: {},
    alerts: [],
    selectedAlert: {},
    loading: {
      localWeather: false,
      microWeather: false,
      alerts: false,
      dailyTemps: false,
    },
    alertsDashboard: {},
    tasksDashboard: {},
    recentComments: [],
    showClimate: false,
    dailyTemps: {},
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    async loadWeather({ commit }) {
      commit('setLoading', {
        localWeather: true,
        microWeather: true,
      });

      GetLocalWeather().then((localWeather) => {
        commit('setLocalWeather', localWeather);
        commit('setLoading', {
          localWeather: false,
        });
      });

      GetMicroWeather().then((microWeather) => {
        commit('setMicroWeather', microWeather);
        commit('setLoading', {
          microWeather: false,
        });
      });

      GetWeatherPrecipitation().then((weatherPrecipitation) => {
        commit('setWeatherPrecipitation', weatherPrecipitation);
      });
    },

    async loadAlerts({ commit }) {
      commit('setLoading', {
        alerts: true,
      });

      await GetAlertByCourse().then((response) => {
        commit('setAlerts', response.alerts);
        commit('setLoading', {
          alerts: false,
        });
      });
    },

    async loadAlertsDashboard({ commit }) {
      commit('setLoading', {
        alerts: true,
      });

      await GetAlertsDashboard().then((response) => {
        commit('setAlertsDashboard', response);
        commit('setLoading', {
          alerts: false,
        });
      });
    },

    async loadTasksDashboard({ commit }) {
      commit('setLoading', {
        alerts: true,
      });

      await GetTasksDashboard().then((response) => {
        commit('setTasksDashboard', response);
        commit('setLoading', {
          alerts: false,
        });
      });
    },

    async loadRecentCommentsDashboard({ commit }) {
      commit('setLoading', {
        alerts: true,
      });

      await GetRecentCommentsDashboard().then((response) => {
        commit('setRecentCommentsDashboard', response);
        commit('setLoading', {
          alerts: false,
        });
      });
    },

    async loadMinMaxTempsWeather({ commit }) {
      commit('setLoading', {
        dailyTemps: true,
      });

      await GetStationMinMaxTemps(this.state.Dashboard.microWeather[0].station.device_sn).then((response) => {
        commit('setDailyTemps', response[0]);
        commit('setLoading', {
          dailyTemps: false,
        });
      });
    },
  },

  mutations: { /* Mutations are responsible to change the state */
    setShowClimate(state, showClimate) {
      state.showClimate = showClimate;
    },

    setLocalWeather(state, localWeather) {
      state.localWeather = localWeather;
    },

    setMicroWeather(state, microWeather) {
      state.microWeather = microWeather;
    },

    setWeatherPrecipitation(state, weatherPrecipitation) {
      state.weatherPrecipitation = weatherPrecipitation;
    },

    setAlerts(state, alerts) {
      state.alerts = alerts;
    },

    setAlertsDashboard(state, alerts) {
      state.alertsDashboard = alerts;
    },

    setTasksDashboard(state, tasks) {
      state.tasksDashboard = tasks;
    },

    setRecentCommentsDashboard(state, comments) {
      state.recentComments = comments;
    },

    setSelectedAlert(state, alert) {
      state.selectedAlert = alert;
    },

    setDailyTemps(state, dailyTemps) {
      state.dailyTemps = dailyTemps;
    },

    setLoading(state, loading) {
      state.loading = { ...state.loading, loading };
    },

  },

};
